export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/stylus-loader/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./footer.vue?vue&type=style&index=0&id=278c512f&lang=stylus&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.vue?vue&type=style&index=0&id=278c512f&lang=stylus&scoped=true&
// module id = 561
// module chunks = 16